
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from 'rxjs';
import { CalculatePlanETARequest } from "../../domain";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class CalculateHDPlanETAUsecase implements UseCase<CalculatePlanETARequest, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: CalculatePlanETARequest): Observable<boolean> {
    return this.planRepository.calculateHDPlanETA(params);
  }

}
